// 比赛信息
const eventCode = 250871;

export const EventInfo = {
    eventCode: eventCode,
    eventCodeSignUp: 250869, // 报名列表，从这个列表中获取报名名单
    channel: "2025",
    places: [  // 线下赛场
        // {id: 0, name: "上海（7月12-13日）"},
        // {id: 1, name: "北京（7月12-13日）"},
        // {id: 3, name: "青岛（7月12-13日）"},
        // {id: 4, name: "南京（7月12-13日）"},
        // {id: 8, name: "海口（7月12-13日）"},
        // {id: 10, name: "西安（7月12-13日）"},
        // {id: 12, name: "兰州（7月12-13日）"},
        // {id: 14, name: "南平（7月12-13日）"},
        // {id: 16, name: "太原（7月12-13日）"},
        
        // {id: 15, name: "香港（7月12-13日）"},
        {id: 6, name: "长沙（8月2-3日）"},
        {id: 7, name: "昆明（8月2-3日）"},
        {id: 9, name: "信阳（8月2-3日）"},
        {id: 11, name: "贵阳（8月2-3日）"},
        {id: 13, name: "呼和浩特（8月2-3日）"},
        {id: 17, name: "都江堰（8月2-3日）"},
        {id: 18, name: "沈阳（8月2-3日）"},
        {id: 19, name: "天津（8月2-3日）"},
        {id: 20, name: "乌鲁木齐（8月2-3日）"},
        {id: 21, name: "珠海（8月2-3日）"},
    ],
}

export function eventInfo() {
    let info = {};
    info.eventCode = eventCode;
    info.channel = "2025";
    info.showSignUpBtn = false; // 是否显示注册按钮
    info.autoReg = false; // 自动报名开关：true-登录后，若未报名，可选择组别报名；false-必须由后台导入报名
    info.needPsw = true;
    info.timeLimit = false;
    info.needVip = false; //true-只有VIP用户才能参加，false-所有用户都可以参加
    info.orgIds = [] // 可以参加活动的机构id，为空时所有机构都可参加
    info.bannerLinks = [{
    //     name: "预选赛排行榜：第1场",
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=231104"
    // }, {
    //     name: "2",
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=231118"
    // }, {
    //     name: "3", // 会员专场
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=231202"
    // }, {
    //     name: "4",
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=231216"
    // }, {
    //     name: "5", // 学校专场
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=240102"
    // }, {
    //     name: "6",
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=240120"
    // }, {
    //     name: "7", // 会员专场
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=240218"
    // }, {
    //     name: "8", // 会员专场
    //     link: "https://ix.icode.org.cn/rankBoard?eventCode=240323"
    // }, {
           name: "排行榜7月场", // 7月决赛
           link: "https://ix.icode.org.cn/rankBoard?eventCode=250870"
       }, {
           name: "8月场", // 7月决赛
           link: "https://ix.icode.org.cn/rankBoard?eventCode=250871"
       }, {
        name: "学习平台",
        link: "https://home.icode.org.cn"
    },
    ];

    info.rankTitle = "第七届ICode国际青少年编程竞赛（中国区决赛）";
    info.showSchoolRank = true; // 是否显示学校榜
    info.cameraTest = true;
    info.notice = "7月份比赛已结束，8月比赛时间如下" + "<br>" +
        "比赛日第一天（8月2日）：" + "<br>" +
        " · 图形化小高组：09:30-10:30" + "<br>" +
        " · 图形化小低组：14:30-15:30" + "<br>" +
        "比赛日第二天（8月3日）：" + "<br>" +
        " · Python中学组：09:30-10:30" + "<br>" +
        " · Python小学组：14:30-15:30" + "<br>";

    info.bgFileUrl = "" // 自定义背景图链接地址，若不使用自定义背景则为""
    info.bgIndex = 3; // 默认背景图编号：0-10
    info.pageText = {
        title: "第七届ICode国际青少年编程竞赛（中国区决赛）", // 主标题
        subTitle: "报名时间：2025.05.12-06.22", // 副标题
        // 下方单位信息
        orgList: [
            "主办单位：ICODE中国区组委会",
            "技术支持：立乐教育科技（上海）有限公司"
        ]
    };
    info.eventGameList = [{
        name: "图形化小低组", // 组别名称
        id: eventCode * 100 + 1, // 活动ID
        mode: 0, // 活动模式：0-积木，1-Python
        minGrade: 0, // 组别最低年级（包含，1-12）
        maxGrade: 3 // 组别最高年级（包含，1-12）
    }, {
        name: "图形化小高组",
        id: eventCode * 100 + 2,
        mode: 0,
        minGrade: 4,
        maxGrade: 6
    }, {
        name: "Python小学组",
        id: eventCode * 100 + 11,
        mode: 1,
        minGrade: 0,
        maxGrade: 6
    }, {
        name: "Python中学组",
        id: eventCode * 100 + 12,
        mode: 1,
        minGrade: 7,
        maxGrade: 13
    }];
    return info;
}


// WEBPACK FOOTER //
// ./src/components/contest/2025_final/eventConfig.js